import { createGlobalStyle } from "styled-components";
import LAB디지털폰트 from "../assets/fonts/LAB.ttf";

const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: "LABDigital";
        src: local("LABDigital"), url(${LAB디지털폰트}) format('truetype');
    }


  * { font-family: 'LABDigital', sans-serif; box-sizing:border-box}

  body {
    margin: 0;
    padding: 0;
    overflow-y: scroll;
    background-color: ${({ theme }) => theme.color.background};
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }

  .swal2-shown { 
    padding-right: 0px !important; 
    overflow: unset !important;
  }

  a, a:link, a:visited, a:focus {
    color: ${({ theme }) => theme.color.text_500};
    text-decoration: none;
    font-weight: ${({ theme }) => theme.font.weight.regular};
  }

  a:hover {
    color: ${({ theme }) => theme.color.gray_600};
  }

  a,
  a:link,
  a:hover,
  a:active,
  a:visited {
    -webkit-transition: none !important;
    -moz-transition: none !important;
    -o-transition: none !important;
    transition: none !important;
  }

  input[type="text"],
  input[type="password"],
  input[type="email"] {
    width: 100%;
    height: auto; // 높이 초기화
    line-height: normal; // line-height 초기화
    /* border-radius: 0; */
    outline: none;
    outline-style: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  button,
  input[type="submit"],
  input[type="button"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    box-shadow: none;
    border: none;
    outline: 0;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
  }

  button:active,
  button:hover,
  button:focus,
  input[type="submit"]:active,
  input[type="submit"]:hover,
  input[type="submit"]:focus,
  input[type="button"]:active,
  input[type="button"]:hover,
  input[type="button"]:focus {
    outline: 0;
  }
`;

export default GlobalStyle;
